import { Box, Flex, Input, InputProps, Text } from "@chakra-ui/react";
import { ChangeEvent } from "react";

export interface MinMaxInputProps {
  minValue?: string | number;
  maxValue?: string | number;
  onChangeMin?: (value: string) => void;
  onChangeMax?: (value: string) => void;
  inputType?: "number" | "date" | "text";
  isDisabled?: boolean;
  minInputProps?: InputProps;
  maxInputProps?: InputProps;
}

export function MinMaxInput({
  minValue,
  maxValue,
  onChangeMin,
  onChangeMax,
  inputType = "number",
  isDisabled,
  minInputProps,
  maxInputProps
}: MinMaxInputProps) {
  const handleMinChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChangeMin?.(e.target.value);
  };

  const handleMaxChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChangeMax?.(e.target.value);
  };

  const sharedInputStyle: InputProps = {
    size: "sm",
    borderRadius: "8px",
    bg: "white",
    border: "1px solid",
    borderColor: "#E2E8F0",
    fontSize: "13px",
    color: "#334155",
    _placeholder: { color: "#CBD5E1", fontSize: "12px" },
    _focus: { borderColor: "#93C5FD", boxShadow: "0 0 0 2px #DBEAFE" },
    _disabled: { bg: "#F8FAFC", color: "#90a1b9", cursor: "not-allowed" },
    boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)"
  };

  return (
    <Flex align="center" gap="6px">
      <Input
        value={minValue ?? ""}
        onChange={handleMinChange}
        placeholder="mín."
        type={inputType}
        isDisabled={isDisabled}
        {...sharedInputStyle}
        {...minInputProps}
      />
      <Text
        fontSize="11px"
        color="#90a1b9"
        fontWeight="500"
        flexShrink={0}
        userSelect="none"
      >
        até
      </Text>
      <Input
        value={maxValue ?? ""}
        onChange={handleMaxChange}
        placeholder="máx"
        type={inputType}
        isDisabled={isDisabled}
        {...sharedInputStyle}
        {...maxInputProps}
      />
    </Flex>
  );
}
